import { useOutletContext } from "react-router-dom";

export function usePayload() {
  return useOutletContext<any>();
}
